import { ErrorViewType } from './config';
import icNetwork from 'assets/svg/ic_wrong_network_V2.svg';
import icError from 'assets/img/ic_error_v2.png';
export function generateErrorConfig(config) {
  switch (config.type) {
    case ErrorViewType.Offline:
      return {
        title: 'WRONG NETWORK',
        content: 'You need to connect to supported network',
        img: icNetwork
      };

    case ErrorViewType.Unknown:
      return {
        title: 'OOPS!',
        content: 'Something went wrong. Please try again ',
        img: icError
      };

    case ErrorViewType.Generic:
      return {
        title: 'Something went wrong',
        content: config.error.toString(),
        img: icError
      };

    case ErrorViewType.Custom:
      return {
        title: config.type === ErrorViewType.Custom ? config.title : '',
        content: config.type === ErrorViewType.Custom ? config.content : '',
        img: config.img || icError
      };

    default:
      return {
        title: 'OOPS!',
        content: 'Something went wrong. Please try again.',
        img: icError
      };
  }
}